<template>
    <div class="warpper">
        <div class="info" v-html="orginizInfo.morgdesc">
        </div>
    </div>
</template>

<script>
    import {getOrganizInfo} from '@/api/member'
    export default {
        name: "intro",
        components: {},
        data() {
            return {
                orginizInfo: '',
            }
        },
        created() {
            this.$emit('setIndex', 0, '机构介绍')
            this.init()
        },
        methods: {
            async init() {
                let _data = await getOrganizInfo()
                if (_data.status === 200) {
                    this.orginizInfo = _data.data
                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 30px 112px;
        .info{
            word-break: break-word;
        }
    }
</style>